<template>
  <div class="volume-indicator">
    <div
      v-for="(box, index) in boxes"
      :key="index"
      :class="{ active: index < activeBoxes }"
      class="volume-box"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    volume: {
      type: Number,
      default: 0,
      validator: (val) => val >= 0 && val <= 100,
    },
    boxCount: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    // 计算应该激活的盒子数量
    activeBoxes() {
      return Math.ceil(this.volume / (100 / this.boxCount));
    },
    // 生成盒子数组
    boxes() {
      return Array(this.boxCount).fill(0);
    },
  },
};
</script>

<style scoped>
.volume-indicator {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

.volume-box {
  flex: 1;
  height: 8px;
  border-radius: 2px;
  background-color: #52525b;
  transition: background-color 0.2s ease;
}

.volume-box.active {
  background-color: #009a29; /* 绿色 */
}
</style>
